import { ChipToggleGroup, ChipToggleOption } from '@app/components/chip-toggle-group';
import { useUiStore } from '@app/core/ui/stores/ui.store';
import { ThemeMode } from '@app/core/ui/theme-mode';
import ContrastOutlinedIcon from '@mui/icons-material/ContrastOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useTheme } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const defaultModeLabelMessage = defineMessage({
  id: 'core.sidenav.defaultModeLabel',
  defaultMessage: 'Default',
});

const lightModeLabelMessage = defineMessage({
  id: 'core.sidenav.lightModeTooltip',
  defaultMessage: 'Claro',
});

const darkModeLabelMessage = defineMessage({
  id: 'core.sidenav.darkModeTooltip',
  defaultMessage: 'Oscuro',
});

/**
 * Exclusive chip group to pick Default (mixed), Dark, or true Light theme
 * from the account popover. Mode ids stay `light` / `dark` / `light-full` for persistence.
 */
export function ThemeToggle() {
  const setThemeMode = useUiStore((state) => state.setThemeMode);
  const themeMode = useUiStore((state) => state.themeMode);
  const theme = useTheme();
  const $t = useIntl().formatMessage;

  const options: ChipToggleOption[] = [
    {
      value: 'light',
      label: $t(defaultModeLabelMessage),
      chipColor: theme.palette.grey[500],
      filledLabelColor: theme.palette.common.white,
      icon: <ContrastOutlinedIcon fontSize="small" />,
    },
    {
      value: 'dark',
      label: $t(darkModeLabelMessage),
      chipColor: theme.palette.grey[700],
      filledLabelColor: theme.palette.common.white,
      icon: <DarkModeOutlinedIcon fontSize="small" />,
    },
    {
      value: 'light-full',
      label: $t(lightModeLabelMessage),
      chipColor: theme.palette.warning.main,
      filledLabelColor: theme.palette.warning.contrastText,
      icon: <LightModeOutlinedIcon fontSize="small" />,
    },
  ];

  return (
    <ChipToggleGroup
      value={themeMode}
      onChange={(next) => setThemeMode(next as ThemeMode)}
      options={options}
      sx={{
        width: '100%',
        '& .MuiChip-root': { flex: 1 },
      }}
    />
  );
}
